import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateListSearch } from '@/shared/lib/listSearch';

/**
 * Settings is where agency administration lives: the agency itself, its
 * members, and its outstanding invitations.
 *
 * These are sub-routes rather than tab state so a tab is linkable and survives
 * a refresh — the same reason list state lives in the URL. Members and
 * invitations are both paginated lists, so they carry the standard list search.
 */
export const settingsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/settings',
  component: lazyRouteComponent(() => import('./pages/AgencySettingsPage'), 'AgencySettingsPage'),
});

export const membersRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/settings/members',
  component: lazyRouteComponent(() => import('./pages/MembersPage'), 'MembersPage'),
  validateSearch: validateListSearch,
});

export const invitationsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/settings/invitations',
  component: lazyRouteComponent(() => import('./pages/InvitationsPage'), 'InvitationsPage'),
  validateSearch: validateListSearch,
});

/** Workflow, teams and labels — the agency-level vocabulary of the Tasks board. */
export const taskStatusesRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/settings/statuses',
  component: lazyRouteComponent(() => import('./pages/TaskStatusesPage'), 'TaskStatusesPage'),
});

export const teamsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/settings/teams',
  component: lazyRouteComponent(() => import('./pages/TeamsPage'), 'TeamsPage'),
});

export const taskLabelsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/settings/labels',
  component: lazyRouteComponent(() => import('./pages/TaskLabelsPage'), 'TaskLabelsPage'),
});

export const settingsRoutes = [
  settingsRoute,
  membersRoute,
  invitationsRoute,
  taskStatusesRoute,
  teamsRoute,
  taskLabelsRoute,
];
